import { CHURNKEY_APP_ID } from "@/settings";

let pending: Promise<void> | null = null;

export function loadChurnkey(): Promise<void> {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.churnkey?.check) return Promise.resolve();
  if (pending) return pending;

  pending = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://assets.churnkey.co/js/app.js?appId=${CHURNKEY_APP_ID}`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      pending = null;
      script.remove();
      reject(new Error("Churnkey script failed to load"));
    };
    document.head.appendChild(script);
  });

  return pending;
}
